import { Component, Input } from '@angular/core';
import { UiIcon } from '../../../common/components/ui/ui-icon/ui-icon.models';

export interface SvgAsset {
    icon: UiIcon.Svg,
    baseColor: string,
    /**
     * Inverts color mode
     * With invertedColor set to true the baseColor is used as 'text color' while a much ligther vesion of baseColor is used for background
     * @type {boolean}
     */
    invertedColor?: boolean,
    strokeHasGradient?: boolean,
    /** State (color) overwrites baseColor and it's behaviour
     * @type {SvgAssetState}
     */
    state?: SvgAssetState
};

export enum SvgAssetState {
    DANGER = 'danger',
    PRIMARY = 'primary'
};

@Component({
    selector: 'business-assets-svg',
    templateUrl: './business-assets-svg.component.html',
    styleUrls: ['./business-assets-svg.component.scss'],
    host: {
        '[class.business-assets-svg]': 'true'
    }
})
export class BusinessAssetsSvgComponent {

    @Input() id: string; // NEEDS to be unique
    @Input() assets: Array<SvgAsset> = [];
    @Input() strokeWidth = 1;
    @Input() ellipseBaseSize = 118;
    @Input() iconBaseSize = 32;

}
